(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["np-test-viewers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('np-test-viewers')) {
    customElements.define('np-test-viewers', class extends HTMLElement {
      connectedCallback() {
        clearTimeout(this.timer);
        this.count = 7;
        this.schedule();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
      }
      schedule() {
        this.timer = setTimeout(() => {
          if (!document.hidden) {
            let next = 4 + Math.floor(Math.random() * 5);
            if (next >= this.count) next += 1;
            this.count = next;
            const target = this.querySelector('[data-viewer-count]');
            if (target) target.textContent = String(next);
          }
          this.schedule();
        }, 8000 + Math.floor(Math.random() * 7001));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
